/**
 * Estados del procesamiento de solicitudes de webhook de Wompi
 */
export enum WompiRequestStatus {
  Received = 'Received',
  Processing = 'Processing',
  Success = 'Success',
  Failed = 'Failed'
}

/**
 * Interfaz para listado de solicitudes de webhook de Wompi
 */
export interface WompiWebhookRequest {
  id: number;
  transactionId: string;
  reference?: string | null;
  requestDate: Date | string;
  processedDate?: Date | string | null;
  status: WompiRequestStatus;
  event?: string | null;
  transactionStatus?: string | null;
  amountInCents: number;
  currency?: string | null;
  customerEmail?: string | null;
  customerName?: string | null;
  paymentMethodType?: string | null;
  paymentLinkId?: string | null;
  errorMessage?: string | null;
  failureStep?: string | null;
  retryCount: number;
  paymentLinkId_Internal?: number | null;
  enrollmentId?: number | null;
  participantId?: number | null;
  lastRetryDate?: Date | string | null;
  processingTimeMs?: number | null;
  environment?: string | null;
}

/**
 * Interfaz detallada para una solicitud de webhook de Wompi
 */
export interface WompiWebhookRequestDetail {
  id: number;
  transactionId: string;
  reference?: string | null;
  requestDate: Date | string;
  processedDate?: Date | string | null;
  status: WompiRequestStatus;
  event?: string | null;
  transactionStatus?: string | null;
  amountInCents: number;
  currency?: string | null;
  customerEmail?: string | null;
  customerName?: string | null;
  customerLegalId?: string | null;
  customerLegalIdType?: string | null;
  paymentMethodType?: string | null;
  paymentLinkId?: string | null;
  rawWebhookData?: string | null;
  errorMessage?: string | null;
  errorDetails?: string | null;
  failureStep?: string | null;
  retryCount: number;
  paymentLinkId_Internal?: number | null;
  enrollmentId?: number | null;
  participantId?: number | null;
  lastRetryDate?: Date | string | null;
  httpRequestInfo?: string | null;
  processingTimeMs?: number | null;
  completedStep?: string | null;
  environment?: string | null;
  wompiTimestamp?: number | null;
  transactionFinalizedAt?: Date | string | null;
  paymentMethodInfo?: string | null;
  processingLogs?: string | null;
  createdAt: Date | string;
  createdBy?: string | null;
  updatedAt: Date | string;
  updatedBy?: string | null;
}

/**
 * Interfaz para un log individual del procesamiento
 * Nota: Las propiedades están en PascalCase porque así vienen del backend C#
 */
export interface ProcessingLogEntry {
  Timestamp: string;
  Level: 'INF' | 'WRN' | 'ERR';
  Code?: string;
  Message: string;
}

/**
 * Interfaz para filtrar solicitudes
 */
export interface WompiWebhookRequestFilter {
  status?: WompiRequestStatus;
  transactionId?: string;
  reference?: string;
  customerEmail?: string;
  transactionStatus?: string;
  paymentMethodType?: string;
  fromDate?: Date | string;
  toDate?: Date | string;
  failureStep?: string;
  environment?: string;
  paymentLinkId?: string;
  paymentLinkIdInternal?: number;
  // Parámetros de paginación y búsqueda
  pageNumber?: number;
  pageSize?: number;
  searchTerm?: string;
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
}

/**
 * Interfaz para respuesta paginada de solicitudes
 */
export interface WompiPagedResult {
  data: WompiWebhookRequest[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
  firstItemOnPage: number;
  lastItemOnPage: number;
}

/**
 * Interfaz para estadísticas de solicitudes
 */
export interface WompiWebhookStats {
  totalRequests: number;
  receivedRequests: number;
  processingRequests: number;
  successRequests: number;
  failedRequests: number;
  successRate: number;
  commonErrors: { [key: string]: number };
  topTransactionStatuses: { [key: string]: number };
  topPaymentMethods: { [key: string]: number };
  environmentDistribution: { [key: string]: number };
}

